var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock },
    [
      _c("TheProductListBreadcrumbs", {
        class: _vm.bemElement("breadcrumbs"),
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          "breadcrumb-not-as-h1": _vm.breadcrumbNotAsH1
        }
      }),
      _vm._v(" "),
      _c("TheProductListColumnMode"),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [_vm.bemElement("filters-button"), "btn"],
          on: { click: _vm.openFilters }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$msg("filters.quantity.text", "filters", [
                  _vm.appliedFiltersTextQuantity
                ])
              ) +
              "\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }